import $ from "jquery";
import lazySizes from "lazysizes";

// Setting Up Media Queries for all the responsive images.
lazySizes.cfg.customMedia = {
	"--small": "(max-width: 320px)",
	"--medium": "(min-width: 321px) and (max-width: 768px)",
	"--large": "(min-width: 769px) and (max-width: 1024px)",
};
export default {
	init() {
		// Sliders Data Setup
		const heroSliderData = {
				dots: true,
				arrows: false,
				infinite: true,
				speed: 1000,
				fade: true,
				autoplay: true,
				autoplaySpeed: 6000,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				adaptiveHeight: true,
			},
			testimonialSliderData = {
				dots: true,
				arrows: false,
				infinite: true,
				speed: 1000,
				fade: true,
				autoplay: true,
				autoplaySpeed: 8000,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				adaptiveHeight: true,
			},
			testimonialSliderDataWithArrows = {
				dots: true,
				arrows: true,
				infinite: true,
				speed: 1000,
				fade: true,
				autoplay: true,
				autoplaySpeed: 8000,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				adaptiveHeight: true,
				prevArrow: $('.slick-prev'),
				nextArrow: $('.slick-next')
			},
			ourHistoryData = {
				dots: false,
				arrows: true,
				infinite: true,
				speed: 1000,
				fade: false,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: true,
				slidesToShow: 5,
				slidesToScroll: 1,
				variableWidth: false,
				adaptiveHeight: true,
				responsive: [
					{
						breakpoint: 1280,
						settings: {
							slidesToShow: 5,
						},
					},
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
						},
					},
					{
						breakpoint: 300,
						settings: {
							slidesToShow: 1,
						},
					},
				],
				prevArrow:
					'<button class="slider__arrow slider__arrow--prev svg-prev"></button>',
				nextArrow:
					'<button class="slider__arrow slider__arrow--next svg-next"></button>',
			};
		const mapQuotesData = {
			dots: false,
			arrows: true,
			infinite: true,
			speed: 1000,
			fade: true,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: false,
			adaptiveHeight: true,
			prevArrow:
				'<div class="svg-prev"><svg width="33" height="18" viewBox="0 0 33 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.3109 3.06066C10.8967 2.47487 10.8967 1.52513 10.3109 0.93934C9.72512 0.353553 8.77537 0.353553 8.18958 0.93934L10.3109 3.06066ZM2.00024 9.25L0.939584 8.18934C0.353798 8.77513 0.353798 9.72487 0.939584 10.3107L2.00024 9.25ZM8.18958 17.5607C8.77537 18.1464 9.72512 18.1464 10.3109 17.5607C10.8967 16.9749 10.8967 16.0251 10.3109 15.4393L8.18958 17.5607ZM8.18958 0.93934L0.939584 8.18934L3.0609 10.3107L10.3109 3.06066L8.18958 0.93934ZM0.939584 10.3107L8.18958 17.5607L10.3109 15.4393L3.0609 8.18934L0.939584 10.3107Z" fill="#00EAC3"/><line x1="1.5" y1="-1.5" x2="28.5" y2="-1.5" transform="matrix(1 0 0 -1 2.25024 7.60303)" stroke="#00EAC3" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></div>',
			nextArrow:
				'<div class="svg-next"><svg width="33" height="18" viewBox="0 0 33 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.4601 3.06066C21.8743 2.47487 21.8743 1.52513 22.4601 0.93934C23.0459 0.353553 23.9956 0.353553 24.5814 0.93934L22.4601 3.06066ZM30.7708 9.25L31.8314 8.18934C32.4172 8.77513 32.4172 9.72487 31.8314 10.3107L30.7708 9.25ZM24.5814 17.5607C23.9956 18.1464 23.0459 18.1464 22.4601 17.5607C21.8743 16.9749 21.8743 16.0251 22.4601 15.4393L24.5814 17.5607ZM24.5814 0.93934L31.8314 8.18934L29.7101 10.3107L22.4601 3.06066L24.5814 0.93934ZM31.8314 10.3107L24.5814 17.5607L22.4601 15.4393L29.7101 8.18934L31.8314 10.3107Z" fill="#00EAC3"/><line x1="29.0208" y1="9.10303" x2="2.02075" y2="9.10303" stroke="#00EAC3" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></div>',
		};
		const blocksSliderData = {
			dots: false,
			arrows: true,
			infinite: true,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			variableWidth: false,
			adaptiveHeight: true,
			prevArrow:
				'<div class="slick-prev"><svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.1666 20.4281L2.73855 11L12.1666 1.57191" stroke="#250144" stroke-width="2.5"/></svg></div>',
			nextArrow:
				'<div class="slick-next"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1669 1.57191L19.5949 11L10.1669 20.4281" stroke="#250144" stroke-width="2.5"/></svg></div>',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		};

		const customerSliderData = {
			dots: false,
			arrows: true,
			infinite: true,
			speed: 1000,
			fade: false,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: false,
			slidesToShow: 6,
			slidesToScroll: 1,
			variableWidth: false,
			adaptiveHeight: false,
			responsive: [
				{
					breakpoint: 1280,
					settings: {
						slidesToShow: 5,
					},
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 4,
					},
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 300,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		};
		const awardsSliderData = {
			dots: false,
			arrows: true,
			infinite: true,
			speed: 1000,
			fade: false,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			variableWidth: false,
			adaptiveHeight: false,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		};

		const portfolioSliderData = {
			dots: true,
			arrows: false,
			infinite: true,
			speed: 1000,
			fade: true,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: false,
			adaptiveHeight: true,
			asNavFor: ".portfolio-slider-nav",
		};
		const portfolioSliderNav = {
			centerMode: true,
			dots: false,
			arrows: false,
			infinite: true,
			speed: 1000,
			fade: false,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			variableWidth: false,
			adaptiveHeight: false,
			asNavFor: ".portfolio-slider",
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 4,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		};

		const largeWordSliderData = {
			dots: true,
			arrows: false,
			infinite: true,
			speed: 1000,
			fade: true,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: false,
			adaptiveHeight: true,
			asNavFor: ".large-word-slider-nav",
		};
		const largeWordSliderNav = {
			centerMode: true,
			dots: false,
			arrows: false,
			infinite: true,
			speed: 1000,
			fade: false,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: false,
			adaptiveHeight: false,
			asNavFor: ".large-word-slider",
		};
		const verticalsSliderData = {
			centerPadding: "0px",
			centerMode: true,
			dots: false,
			arrows: true,
			infinite: true,
			speed: 1000,
			fade: false,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnFocus: true,
			pauseOnHover: true,
			pauseOnDotsHover: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			variableWidth: false,
			adaptiveHeight: false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		};
		const verticalsSliderAltData = {
			centerPadding: "0px",
			centerMode: false,
			dots: false,
			arrows: true,
			infinite: true,
			speed: 1000,
			fade: false,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnFocus: true,
			pauseOnHover: true,
			pauseOnDotsHover: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			variableWidth: false,
			adaptiveHeight: false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		};
		const latestNewsInnerData = {
			variableWidth: false,
			adaptiveHeight: false,
			dots: false,
			appendArrows: $("#slider-arrows"),
			arrows: true,
			infinite: true,
			speed: 800,
			fade: false,
			autoplay: true,
			autoplaySpeed: 6000,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 560,
					settings: {
						slidesToShow: 1,
						autoplay: false,
					},
				},
			],
		};

		const industriesLogosData = {
			slidesToShow: 5,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 0,
			speed: 9000,
			cssEase: "linear",
			arrows: false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 5,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 4,
					},
				},
				{
					breakpoint: 560,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		};
		const blockStatsCarousel = {
			variableWidth: false,
			adaptiveHeight: false,
			dots: false,
			appendArrows: $("#stats-carousel-arrows"),
			arrows: true,
			infinite: true,
			speed: 800,
			fade: false,
			autoplay: true,
			autoplaySpeed: 6000,
			slidesToShow: 1,
			slidesToScroll: 1,
		};
		// Sliders
		$(".hero-slider").slick(heroSliderData);

		$(".slider--our-history").slick(ourHistoryData);

		$(".testimonial-slider.has-arrows").slick(testimonialSliderDataWithArrows);
		$(".testimonial-slider:not(.has-arrows)").slick(testimonialSliderData);

		$(".map-quotes .quotes").slick(mapQuotesData);

		$(".ai-block--column-blocks-slider .blocks-wrapper").slick(
			blocksSliderData
		);
		$(".ai-block--column-blocks-slider .blocks-wrapper").on(
			"afterChange",
			function (event, slick, currentSlide, nextSlide) {
				$(".match-height").matchHeight({
					byRow: false,
					property: "min-height",
				});
			}
		);

		$(".customers-slider").slick(customerSliderData);

		$(".awards-slider").slick(awardsSliderData);

		if ($(".portfolio-slider-nav").length > 0) {
			$(".portfolio-slider").slick(portfolioSliderData);

			$(".portfolio-slider-nav").slick(portfolioSliderNav);
		} else {
			$(".portfolio-slider").slick({
				dots: true,
				arrows: false,
				infinite: true,
				speed: 1000,
				fade: true,
				autoplay: true,
				autoplaySpeed: 6000,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				adaptiveHeight: true,
			});
		}

		$(".large-word-slider").slick(largeWordSliderData);

		$(".large-word-slider-nav").slick(largeWordSliderNav);

		$(".verticals-slider").slick(verticalsSliderData);
		$(".verticals-slider .content-wrapper").each(function () {
			$(this).css("height", $(this).height());
			$(this).addClass("loaded");
		});

		$(".verticals-slider-alt").slick(verticalsSliderAltData);
		$(".verticals-slider-alt .content-wrapper .lower-content").each(
			function () {
				$(this).css("height", $(this).height());
				$(this).parents(".content-wrapper").addClass("loaded");
			}
		);

		if ($(".ai-block-latest-news-carousel .latest-news-inner").length) {
			$(".ai-block-latest-news-carousel .latest-news-inner").slick(
				latestNewsInnerData
			);
		}

		if ($(".ai-block-resources-carousel").length) {
			const resourcesCarousel = $(".ai-block-resources-carousel");
			resourcesCarousel.each((index, element) => {
				const resourceArrows = $(element).find(".resources-slider-arrows")
					? $(element).find(".resources-slider-arrows")
					: null;
				const slickResourcesData = {
					variableWidth: false,
					adaptiveHeight: false,
					dots: false,
					appendArrows: resourceArrows,
					arrows: true,
					infinite: true,
					speed: 1000,
					fade: false,
					autoplay: false,
					autoplaySpeed: 6000,
					slidesToShow: 3,
					slidesToScroll: 1,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: 560,
							settings: {
								slidesToShow: 1,
							},
						},
					],
				};
				const resourceWrapper = $(element).find(".resources-wrapper");
				if (resourceWrapper.length) {
					// if ($(element).hasClass("style-netreveal") === false) {
					//     resourceWrapper.slick(slickResourcesData);
					//     return;
					// }

					// if ($(element).hasClass("resource-type-news")) {
					//     resourceWrapper.slick(slickResourcesData);
					//     return;
					// }

					// if ($(element).hasClass("resource-type-manual")) {
					//     resourceWrapper.slick(slickResourcesData);
					//     return;
					// }

					resourceWrapper.slick(slickResourcesData);
				}
			});
		}

		if ($(".ai-block-logo-slider#industries-logos").length) {
			$(".ai-block-logo-slider#industries-logos .inner-track").slick(
				industriesLogosData
			);
		}

		if ($(".ai-block-netreveal-stats-carousel").length) {
			$(".ai-block-netreveal-stats-carousel .stats-wrapper").slick(
				blockStatsCarousel
			);
		}

		if ($(".ai-block-videos-carousel .videos-slider").length) {
			$(".ai-block-videos-carousel").each(function () {
				let wrapper = $(this);
				// console.log(wrapper.find('#videos-slider-arrows'));
				$(this)
					.find(".videos-slider")
					.slick({
						variableWidth: false,
						adaptiveHeight: false,
						dots: false,
						appendArrows: wrapper.find("#videos-slider-arrows"),
						arrows: true,
						infinite: true,
						speed: 1000,
						fade: false,
						autoplay: true,
						autoplaySpeed: 6000,
						slidesToShow: 3,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: "0px",
						responsive: [
							{
								breakpoint: 1024,
								settings: {
									centerMode: true,
									slidesToShow: 3,
								},
							},
							{
								breakpoint: 768,
								settings: {
									centerMode: true,
									slidesToShow: 1,
								},
							},
							{
								breakpoint: 560,
								settings: {
									centerMode: true,
									slidesToShow: 1,
								},
							},
						],
					});
			});
		}

		if ($(".ai-block-webinars-events-featured .we-featured-slider").length) {
			// slider with 3 slides
			if (
				$(".ai-block-webinars-events-featured .we-featured-slider").data(
					"count"
				) == 3
			) {
				$(".ai-block-webinars-events-featured .we-featured-slider").slick({
					autoplay: false,
					variableWidth: false,
					adaptiveHeight: true,
					dots: false,
					appendArrows: $("#featured-slider-arrows"),
					arrows: true,
					infinite: true,
					speed: 1000,
					fade: false,
					autoplaySpeed: 6000,
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: "0px",
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								centerMode: true,
								slidesToShow: 3,
							},
						},
						{
							breakpoint: 840,
							settings: {
								centerMode: true,
								slidesToShow: 1,
							},
						},
						{
							breakpoint: 560,
							settings: {
								centerMode: true,
								slidesToShow: 1,
							},
						},
					],
				});
				// slider with 4 or more
			} else {
				$(".ai-block-webinars-events-featured .we-featured-slider").slick({
					autoplay: false,
					variableWidth: false,
					adaptiveHeight: false,
					dots: false,
					appendArrows: $("#featured-slider-arrows"),
					arrows: true,
					infinite: true,
					speed: 1000,
					fade: false,
					autoplaySpeed: 6000,
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: "0px",
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								centerMode: true,
								slidesToShow: 3,
							},
						},
						{
							breakpoint: 768,
							settings: {
								centerMode: true,
								slidesToShow: 1,
							},
						},
						{
							breakpoint: 560,
							settings: {
								centerMode: false,
								slidesToShow: 1,
							},
						},
					],
				});
			}

			// clicking adjacent slides move that slide to center (active)
			$(".ai-block-webinars-events-featured .we-featured-slider").on(
				"click",
				".slick-slide",
				function (e) {
					e.stopPropagation();
					var index = $(this).data("slick-index");

					if ($(".slick-slider").slick("slickCurrentSlide") !== index) {
						// prevent non-center slide from following clicked link
						e.preventDefault();
						// slide into current slide
						$(".slick-slider").slick("slickGoTo", index);
					}
				}
			);
		}

		function valuesSlides() {
			let width = window.innerWidth;
			if ($(".values-wrapper").length) {
				if (width < 1024) {
					if (!$(".values-wrapper").hasClass("slick-initialized")) {
						$(".values-wrapper").slick({
							slidesToShow: 1,
							centerMode: true,
							swipeToSlide: true,
							variableWidth: false,
							autoplay: false,
							slidesToScroll: 1,
							speed: 400,
							appendArrows: $("#slider-arrows--values"),
						});
					}
					return;
				}
				if ($(".values-wrapper").hasClass("slick-initialized")) {
					$(".values-wrapper").slick("unslick");
				}
			}
		}
		if ($(`.values-wrapper`).length) {
			$(window).on("resize", valuesSlides);
			valuesSlides();
		}
		function responsiveSlides() {
			if ($(".js--slider").length) {
				let width = window.innerWidth;
				if (width < 768) {
					$(".js--slider").each(function (index, element) {
						// let itemSlide = 'grid-item';
						let slickOptions = {
							slidesToShow: 3,
							// centerMode: true,
							swipeToSlide: true,
							arrows: false,
							// variableWidth: true,
							autoplay: true,
							slidesToScroll: 3,
							speed: 400,
						};
						if ($(element).hasClass("grid--brands-partners")) {
							// console.log(`Element hit`);
							slickOptions = {
								slidesToShow: 3,
								// centerMode: true,
								swipeToSlide: true,
								arrows: false,
								// variableWidth: true,
								autoplay: true,
								slidesToScroll: 3,
								speed: 5000,
								autoplaySpeed: 0,
								cssEase: "linear",
							};
						}
						if ($(element).hasClass("static-blocks-wrapper")) {
							slickOptions = {
								slidesToShow: 1,
								centerMode: true,
								swipeToSlide: true,
								// arrows: false,
								// variableWidth: true,
								autoplay: false,
								slidesToScroll: 1,
								speed: 400,
								appendArrows: $(element).next("#slider-arrows--static-blocks"),
							};
						}
						// if ($(element).hasClass('tabs-titles')) {
						// 	slickOptions = {
						// 		slidesToShow: 1,
						// 		variableWidth: true,
						// 		swipeToSlide: true,
						// 		arrows: false,
						// 		autoplay: false,
						// 		slidesToScroll: 1,
						// 		asNavFor: '.tabs-contents',
						// 	};
						// }
						// if ($(element).hasClass('tabs-contents')) {
						// 	slickOptions = {
						// 		slidesToShow: 1,
						// 		// variableWidth: true,
						// 		swipeToSlide: true,
						// 		arrows: false,
						// 		autoplay: false,
						// 		slidesToScroll: 1,
						// 		asNavFor: '.tabs-titles',
						// 	};
						// }

						if (!$(element).hasClass("slick-initialized")) {
							$(element).slick(slickOptions);
						}
					});
					return;
				}
				$(".js--slider").each(function (index, element) {
					if ($(element).hasClass("slick-initialized")) {
						$(element).slick("unslick");
					}
				});
			}
		}
		$(window).on("resize", responsiveSlides);
		responsiveSlides();

		const tabsTitleData = {};
		const tabsContentData = {};
	},
};
